import { RollerShutterConfiguration } from './RollerShutterConfiguration';
import { PriceSegment, DiscountGroups, PricePart } from '@icc/shared/types/price/Prices';
import { RollerMontageType, RollerEndRail, RollerProfile, RollerShutterType, TimeLimitSegment } from '@icc/shared/types';
import { ConfiguratorsDataService, ActiveConfiguration } from '@icc/configurator/shared';
import { Layout } from '../types/layout';
import { RollerShutter } from '../types/roller-shutter';
import { CoverSegment } from '../types/cover-segment';
import { AdditionalPolystyreneInsert, BoxDepthExtension, HorizontalBoxReinforcement, RollerAdapter, RollerCover, RoundReel, StaticBracket, SteelMountingAnchor, SteelSideBracket, MountingBracket, BoxWidthExtension, InspectionHatchSupportBracket, InspectionHatch, PlasterStrip, PlasterStripExtension, BoxSideInsulation, RollerBoxSideCap, RollerGuides, RollerDimensioningType, StaticBracketAmount, RollerGuidesCaps, RollerGuidesChannelCaps, RollerGuidesOverlays, RollerGuidesSpacerStrips, RollerGuidesDrillings, RollerGuidesExtensions, RollerMosquitoScreenType, RollerBlindSide, RollerDrive, RollerWeight, RollerRemoteControl, RollerTapeCordOutput, Packaging } from '@icc/shared/types/roller-shutter';
import { InspectionHatchLocation } from '../types/inspection-hatch-location';
import { RollerMosquitoScreen } from '../types/mosquito-screen';
import { Color } from '../types/color';

export class RollerShutterActiveConfiguration implements ActiveConfiguration {
    type: 'roller_shutter' = 'roller_shutter';
    departments: any = {};
    Name = '';
    Price = 0;
    PriceNoMargin = 0;
    PriceAfterMultiplier = 0;
    PriceAfterMultiplierNoMargin = 0;
    PriceAfterDiscounts = 0;
    PriceIsGross = false;
    PriceTaxRate = 0;
    Quantity = 1;
    Issues: any[] = [];
    PriceSegments: PriceSegment[] = [];
    PriceSegmentsNoMargin: PriceSegment[] = [];
    PriceParts: PricePart[] = [];
    PricePartsNoMargin: PricePart[] = [];
    DiscountGroups: DiscountGroups = {};
    DiscountGroupsNoMargin: DiscountGroups = {};
    PricesRevisions: {
        prices: number;
        priceRasters: number;
        charge: number;
        multiplier: number;
        marketFactor: number;
    } = {
        prices: 0,
        priceRasters: 0,
        charge: 0,
        multiplier: 0,
        marketFactor: 0,
    };
    Discount = 0;
    timeLimit = 0;
    timeLimitsStack: TimeLimitSegment[] = [];
    Title = '';
    Description = '';
    Attachments = [];
    valid: {} = {};
    PriceValid = false;
    drawData: any;

    attributes: {
        id: string;
        name: string;
        value: string;
        valueId?: number;
    }[] = [];

    width = 0;
    height = 0;

    shutterType: RollerShutterType = null;
    /** Przystosowana do typu */
    adaptedForShutterType: RollerShutterType | null = null;
    /** Metoda wymiarowania: `shutter` - wymiar żaluzji, `hole` - wymiar otworu, `window` - wymiar okna */
    dimensioningType: RollerDimensioningType = 'window';
    shutters: RollerShutter[] = [];
    coverSegments: CoverSegment[] = [];
    defaultCoverSegments = true;
    cover: RollerCover = null;
    coverHeight: {
        height: number;
        defaultHeight: number;
        depth: number;
        defaultDepth: number;
        isDefault: boolean;
    } = {
        height: 0,
        defaultHeight: 0,
        depth: 0,
        defaultDepth: 0,
        isDefault: true,
    };
    profile: RollerProfile = null;
    manuallySelectedProfile: RollerProfile | null = null;

    /** Rodzaj perforacji lameli */
    perforationType: 'all_perforated' | 'selected_non_perforated' | 'all_non_perforated' = 'all_perforated';
    /** Liczba nieperforowanych lameli (od góry) */
    nonPerforatedSlatsCount: number | null = null;
    /** Czy perforacja była zmieniana ręcznie przez użytkownika */
    perforationManuallyChanged: boolean = false;

    endRail: RollerEndRail = null;
    /** Czy bufor listwy dolnej występuje w konfiguracji */
    endRailBufferEnabled = false;

    roundReel: RoundReel = null;

    horizontalBoxReinforcements: HorizontalBoxReinforcement[] = [];

    montageType: RollerMontageType = null;
    layout: Layout = {
        id: 0,
        title: '',
        type: 'number',
        connections: [],
    }

    inspectionHatchLocation: InspectionHatchLocation = 'bottom';
    boxDepthExtension: BoxDepthExtension = null;
    additionalPolystyreneInsert: AdditionalPolystyreneInsert = null;
    additionalPolystyreneInsertManuallyAdded: boolean | null = null;
    rollerBoxAdapter: RollerAdapter = null;

    staticBrackets: StaticBracket = null;
    staticBracketsAmount: StaticBracketAmount = {
        amount: 0,
        isDefault: true,
    };
    steelMountingAnchors: SteelMountingAnchor | null = null;
    steelSideBrackets: SteelSideBracket[] = [];
    mountingBrackets: MountingBracket | null = null;
    boxWidthExtensions: BoxWidthExtension[] = [];

    boxWidthExtensionValues: {
        marginLeft: number;
        marginBetween1and2: number;
        marginBetween2and3: number;
        marginRight: number;
    } = {
        marginLeft: 0,
        marginBetween1and2: 0,
        marginBetween2and3: 0,
        marginRight: 0,
    };
    inspectionHatchSupportBrackets: InspectionHatchSupportBracket = null;
    inspectionHatch: InspectionHatch = null;
    plasterStrip: PlasterStrip = null;
    outerPlasterStrip: PlasterStrip = null;
    innerPlasterStrip: PlasterStrip = null;
    outerPlasterStripManuallyRemoved = false;
    innerPlasterStripManuallyRemoved = false;
    plasterStripExtension: PlasterStripExtension = null;

    boxSideInsulation: BoxSideInsulation = null;
    boxSideCap: RollerBoxSideCap = null;

    /** Dodatkowe opakowanie */
    packaging: Packaging | null = null;

    /** Prowadnice */
    guides: RollerGuides[] = [];
    guidesOverlays: RollerGuidesOverlays[] = [];
    guidesCaps: RollerGuidesCaps[] = [];
    guidesSpacerStrips: RollerGuidesSpacerStrips[] = [];
    guidesChannelCaps: RollerGuidesChannelCaps[] = [];
    guidesDrillings: RollerGuidesDrillings[] = [];
    guidesCuttingAngle: number | null = null;
    guidesExtensions: RollerGuidesExtensions[] = [];
    /** Czy zatyczki/zaślepki prowadnic są włączone */
    toggledGuidesCaps: {
        toggled: boolean;
        isDefault: boolean;
    } = { toggled: false, isDefault: true };

    mosquitoScreens: RollerMosquitoScreen[] = [];
    mosquitoScreenExpectation: Record<string, boolean | null> = {};
    mosquitoScreenType: RollerMosquitoScreenType | null = null;

    selectedSides: RollerBlindSide | null = null;

    colors: {
        profile?: Color;
        endRail?: Color;
        guidance?: Color;
        cover?: Color;
        coverOutside?: Color;
        coverInside?: Color;

        inspectionHatch?: Color;
        rollerBoxAdapter?: Color;
        plasterStrip?: Color;
        outerPlasterStrip?: Color;
        innerPlasterStrip?: Color;
        /** Kolory zaślepek/zatyczek dolnych prowadnic */
        guideCaps?: Record<number, {
            left: Color,
            right: Color
        }>;

        guideOverlay?: Color;
        profileGuideChannelCap?: Color;
        mosquitoGuideChannelCap?: Color;
        rolledMosquitoNet?: Color;
        pleatedMosquitoNet?: Color;
        mosquitoEndRail?: Color;
        mosquitoProfile?: Color;

        endRailBuffer?: Color;

        blindSide?: Color;
        rollerGuideSpacerStrip?: Color;

        matchToProfile: boolean;
    } = {
        profile: null,
        endRail: null,
        guidance: null,
        cover: null,
        coverOutside: null,
        coverInside: null,

        inspectionHatch: null,
        rollerBoxAdapter: null,
        plasterStrip: null,
        outerPlasterStrip: null,
        innerPlasterStrip: null,
        guideCaps: {},

        guideOverlay: null,
        profileGuideChannelCap: null,
        mosquitoGuideChannelCap: null,
        rolledMosquitoNet: null,
        pleatedMosquitoNet: null,
        mosquitoEndRail: null,
        mosquitoProfile: null,

        blindSide: null,
        rollerGuideSpacerStrip: null,

        matchToProfile: true,
    };

    drives: RollerDrive[] = [];
    remoteControls: RollerRemoteControl[] = [];

    weight: RollerWeight = {
        endRail: {
            all: 0
        },
        profile: {
            all: 0
        },
        all: 0
    };

    selectedTapeCordOutput: RollerTapeCordOutput | null = null;

    public static is(configuration): configuration is RollerShutterActiveConfiguration {
        return configuration instanceof RollerShutterActiveConfiguration || !configuration.$version;
    }

    constructor(configuration?, private configuratorsDataService?: ConfiguratorsDataService<'roller_shutter'>, langCode?: string) {
        if (configuration) {
            if (RollerShutterActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (this.hasOwnProperty(propName)) {
                        this[propName] = configuration[propName];
                    }
                }
                this.endRailBufferEnabled =
                    configuration.endRailBufferEnabled ??
                    !!this.shutterType?.endRailBufferColorChoice;
                if (!this.endRailBufferEnabled) {
                    delete this.colors.endRailBuffer;
                }
            } else {
                if (RollerShutterConfiguration.is(configuration) && configuratorsDataService) {
                    this.Name = configuration.name;
                    this.departments = configuration.departments;
                    this.Price = configuration.price;
                    this.PriceNoMargin = configuration.priceNoMargin;
                    this.PriceAfterMultiplier = configuration.priceAfterMultiplier;
                    this.PriceAfterMultiplierNoMargin = configuration.priceAfterMultiplierNoMargin;
                    this.PriceAfterDiscounts = configuration.priceAfterDiscounts;
                    this.PriceIsGross = configuration.priceIsGross;
                    this.PriceTaxRate = configuration.priceTaxRate;
                    this.Quantity = configuration.quantity;
                    this.PriceSegments = configuration.priceSegments;
                    this.PriceSegmentsNoMargin = configuration.priceSegmentsNoMargin;
                    this.PriceParts = configuration.priceParts;
                    this.PricePartsNoMargin = configuration.pricePartsNoMargin;
                    this.DiscountGroups = configuration.discountGroups;
                    this.DiscountGroupsNoMargin = configuration.discountGroupsNoMargin;
                    this.PricesRevisions = {
                        prices: configuration.pricesRevisions?.prices || 0,
                        priceRasters: configuration.pricesRevisions?.priceRasters || 0,
                        charge: configuration.pricesRevisions?.charge || 0,
                        multiplier: configuration.pricesRevisions?.multiplier || 0,
                        marketFactor: configuration.pricesRevisions?.marketFactor || 0,
                    };
                    this.Title = configuration.title;
                    this.Description = configuration.description;
                    this.valid = configuration.valid;
                    this.timeLimit = configuration.timeLimit;
                    this.timeLimitsStack = configuration.timeLimitsStack;
                    this.attributes = configuration.attributes;

                    this.dimensioningType = configuration.dimensioningType;
                    this.shutterType = configuration.shutterType;
                    this.adaptedForShutterType = configuration.adaptedForShutterType;
                    this.montageType = configuration.montageType;
                    this.profile = configuration.profile;
                    this.manuallySelectedProfile = configuration.manuallySelectedProfile;

                    this.perforationType = configuration.perforationType || 'all_perforated';
                    this.nonPerforatedSlatsCount = configuration.nonPerforatedSlatsCount;
                    this.perforationManuallyChanged = configuration.perforationManuallyChanged || false;

                    this.endRail = configuration.endRail;
                    this.endRailBufferEnabled =
                        configuration.endRailBufferEnabled ??
                        !!configuration.shutterType?.endRailBufferColorChoice;
                    this.horizontalBoxReinforcements = configuration.horizontalBoxReinforcements || [];

                    this.shutters = configuration.shutters;
                    this.layout = configuration.layout;
                    this.coverSegments = configuration.coverSegments;
                    this.defaultCoverSegments = configuration.defaultCoverSegments;
                    this.cover = configuration.cover;
                    this.coverHeight = configuration.coverHeight;

                    this.roundReel = configuration.roundReel;
                    this.inspectionHatchLocation = configuration.inspectionHatchLocation;
                    this.boxDepthExtension = configuration.boxDepthExtension;
                    this.additionalPolystyreneInsert = configuration.additionalPolystyreneInsert;
                    this.additionalPolystyreneInsertManuallyAdded = configuration.additionalPolystyreneInsertManuallyAdded ?? null;
                    this.rollerBoxAdapter = configuration.rollerBoxAdapter;

                    this.staticBrackets = configuration.staticBrackets;
                    this.staticBracketsAmount = configuration.staticBracketsAmount || {
                        amount: 0,
                        isDefault: true,
                    };
                    this.steelMountingAnchors = configuration.steelMountingAnchors || null;
                    this.steelSideBrackets = configuration.steelSideBrackets || [];
                    this.mountingBrackets = configuration.mountingBrackets;
                    this.boxWidthExtensions = configuration.boxWidthExtensions || [];
                    this.boxWidthExtensionValues = configuration.boxWidthExtensionValues || {
                        marginLeft: 0,
                        marginBetween1and2: 0,
                        marginBetween2and3: 0,
                        marginRight: 0,
                    };
                    this.inspectionHatchSupportBrackets = configuration.inspectionHatchSupportBrackets;
                    this.inspectionHatch = configuration.inspectionHatch;

                    this.plasterStrip = configuration.plasterStrip;
                    this.outerPlasterStrip = configuration.outerPlasterStrip;
                    this.innerPlasterStrip = configuration.innerPlasterStrip;
                    this.outerPlasterStripManuallyRemoved = configuration.outerPlasterStripManuallyRemoved;
                    this.innerPlasterStripManuallyRemoved = configuration.innerPlasterStripManuallyRemoved;

                    this.plasterStripExtension = configuration.plasterStripExtension;

                    this.boxSideInsulation = configuration.boxSideInsulation;
                    this.boxSideCap = configuration.boxSideCap;

                    this.packaging = configuration.packaging || null;

                    this.guides = configuration.guides;
                    this.guidesOverlays = configuration.guidesOverlays || [];
                    this.guidesCaps = configuration.guidesCaps || [];
                    this.guidesSpacerStrips = configuration.guidesSpacerStrips || [];
                    this.guidesChannelCaps = configuration.guidesChannelCaps || [];
                    this.guidesDrillings = configuration.guidesDrillings || [];
                    this.guidesCuttingAngle = configuration.guidesCuttingAngle || null;
                    this.guidesExtensions = configuration.guidesExtensions || [];
                    this.toggledGuidesCaps = configuration.toggledGuidesCaps || { toggled: false, isDefault: true };

                    this.mosquitoScreens = configuration.mosquitoScreens;
                    this.mosquitoScreenExpectation = configuration.mosquitoScreenExpectation;
                    this.mosquitoScreenType = configuration.mosquitoScreenType;

                    this.selectedSides = configuration.selectedSides;

                    this.colors = configuration.colors;

                    this.drives = configuration.drives;
                    this.remoteControls = configuration.remoteControls;
                    this.weight = configuration.weight;
                    this.width = configuration.width;
                    this.height = configuration.height;

                    this.selectedTapeCordOutput = configuration.selectedTapeCordOutput;

                    if (!this.endRailBufferEnabled) {
                        delete this.colors.endRailBuffer;
                    }
                }
            }
        }
        this.configuratorsDataService = null;
    }
}

export type IRollerShutterActiveConfiguration = Pick<
    RollerShutterActiveConfiguration,
    keyof RollerShutterActiveConfiguration
>;
